import { Spin } from 'antd';
import { ThemeRiverChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Data {
  data: Array<[string, number, string]>;
  topics: string[];
}

function ThemeRiverWidget({ instance }: WidgetRenderProps) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id, 'theme-river', instance.config as Record<string, unknown>, instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return <ThemeRiverChart data={data?.data ?? []} topics={data?.topics ?? []} />;
}

export const themeRiverWidgetDef: WidgetDefinition = {
  type: 'theme-river',
  name: 'Theme River',
  description: 'Temporal stream graph',
  icon: 'SwapOutlined',
  category: 'chart',
  defaultTitle: 'Theme River',
  defaultConfig: {},
  minW: 4, minH: 4, defaultW: 6, defaultH: 6,
  component: ThemeRiverWidget,
  settingsSchema: { fields: [] },
};
